import React, { createContext, useState, useContext } from 'react';
import { localStorageKeys } from '../global/constants';
import {
  forgotPasswordAPI,
  loginAPI,
  logoutAPI,
  resetPasswordAPI,
  customerInfoAPI,
  updateCreditCardAPI,
} from './api-services/login.service';
import { StoreHeaderDataContext } from './StoreHeaderDataProvider';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const LoginDataContext = createContext();

const LoginDataProvider = ({ children }) => {
  const {
    onGetKitchenByZipcode,
    kitchensByZipcode,
    isDeliverable,
    setIsDeliverable,
    onGetKitchenByZipcodeHandler,
  } = useContext(StoreHeaderDataContext);
  const {
    REFRESH_TOKEN,
    TOKEN,
    ZIP_CODE,
    KITCHEN_NAMES,
    DEBUG_LOGOUT_POINT,
    CUST_SET_ZIPCODE,
    CUST_SET_KITCHENS,
    CUSTINFO_API_FETCHED_TIME,
    KITCHEN_API_FETCHED_TIME,
    ZIPCODE_GEO_COORDINATES,
  } = localStorageKeys;

  // Very Important varibale hasTokens
  const hasTokens = () => !!(localStorage.getItem(REFRESH_TOKEN) && localStorage.getItem(TOKEN));
  const [isLoggedIn, setIsLoggedIn] = useState(hasTokens()); // ask kuldeep if trigger function in state
  const [fingerPrint, setFingerPrint] = useState('none');
  const [loginData, setLoginData] = useState({
    loading: false,
    data: null,
    errorMessage: '',
    success: null,
  });

  const [forgotPasswordData, setForgotPasswordData] = useState({
    loading: false,
    data: null,
    errors: null,
    errorMessage: '',
  });

  const [resetPasswordData, setResetPasswordData] = useState({
    loading: false,
    data: null,
    success: null,
    errorMessage: '',
  });

  const [customerInfoData, setCustomerInfoData] = useState({
    loading: false,
    data: null,
    success: null,
    errorMessage: '',
    noKitchensFound: null,
  });

  const [updateCreditCardData, setUpdateCreditCardData] = useState({
    loading: false,
    data: null,
    success: null,
    errorMessage: '',
  });

  const setLocalStorageDebug = async (param1, param2) => localStorage.setItem(param1, param2);
  const navigate = useNavigate();
  const RedirectToLogin = async () => navigate('/login');
  const RedirectToUpgradeSubscription = async () => navigate('/upgradesubscription');
  const RedirectToCustAcctSubscription = async () =>
    await navigate('/customeraccount/subscription');
  const triggerLogout = async () => await onLogout();

  const { loading, data, success, errorMessage } = customerInfoData;
  const custInfoData = data?.data || [];
  const custActType = custInfoData?.user_Info?.account_type === 'Subscription';
  const custAccountUnsubscribed =
    custInfoData?.user_Info?.reason_status === 'Customer unsubscribed';
  const custAccountInactive = custInfoData?.user_Info?.reason_status === 'Inactive by admin';
  const custErrorUser = errorMessage === 'User does not exist'; // Logot User and ask to login again
  const custAdminInactive = errorMessage === 'Account is blocked by Administration';
  const zeroPlates = (custInfoData?.subscription_detail?.total_plates_tobe_serve || 0) === 0; // Chck with kuldeep
  const zeroPlatesAvailable = custInfoData?.available_plates === 0;

  const onLogin = async (payload) => {
    try {
      await setLoginData({
        loading: true,
        data: null,
        success: null,
        errorMessage: '',
      });

      const data = await loginAPI(payload);

      if (data.hasError) {
        await setLoginData({
          loading: false,
          data: null,
          success: !data.hasError,
          errorMessage: data.message,
        });
        return;
      }

      if (data.data?.success) {
        await setLoginData({
          loading: false,
          data: data,
          success: data.data?.success,
          errorMessage: null,
        });
        await setCustomerInfoData({
          loading: true,
          success: null,
          data: null,
          errorMessage: '',
          noKitchensFound: null,
        });

        localStorage.setItem(REFRESH_TOKEN, data.data?.refresh_token);
        localStorage.setItem(TOKEN, data.data?.token);
        const custResponse = await onCustomerInformationApiHandler();

        // Passing Data to React Native
        const token = data?.data?.token;
        const managingBranchName = custResponse?.zipCodeData?.data?.managing_branch_name;
        if (window && window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ token, managingBranchName }));
        } else {
          console.log('No RN bridge token');
        }

        return { customerInfoResponse: custResponse, loginResponse: data };
      } else {
        await setLoginData({
          loading: false,
          data: data,
          success: !data.data?.success,
          errorMessage: data.data?.errors[0].CustomMessage,
        });
      }
      return;
    } catch (error) {
      console.log('----Catch block onLogin', error);
      setLoginData({ loading: false, data: null, success: false, errorMessage: error });
    }
  };

  // This Method can only be called when user is logged in
  const onCustomerInformationApiHandler = async () => {
    try {
      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setCustomerInfoData({
          loading: false,
          data: null,
          success: false,
          errorMessage: 'Token & Refresh Token missing',
          noKitchensFound: null,
        });
        return;
      }

      await setCustomerInfoData({
        loading: true,
        success: null,
        data: null,
        errorMessage: '',
        noKitchensFound: null,
      });

      const custdata = await customerInfoAPI();
      if (custdata.hasError) {
        await setCustomerInfoData({
          loading: false,
          data: null,
          success: !custdata.hasError,
          errorMessage: custdata.message,
          noKitchensFound: null,
        });
        return;
      }

      if (custdata.data?.success) {
        await setCustomerInfoData({
          loading: false,
          data: custdata,
          success: custdata.data?.success,
          errorMessage: null,
          noKitchensFound: null,
        });

        let kitchenByZipcodeResponse = null;
        if (!custdata?.data?.kitchens_ForSetDeliveryAddress?.success) {
          await setCustomerInfoData({
            loading: false,
            data: custdata,
            success: custdata.data?.success,
            errorMessage: null,
            noKitchensFound: true,

            // if noKitchensFound =true trigger pop to add address or to trigger logout method
          });
        } else {
          // Set customer zipcode
          await localStorage.setItem(CUSTINFO_API_FETCHED_TIME, custdata?.data?.fetchApiTime);
          await localStorage.setItem(CUST_SET_ZIPCODE, custdata?.data?.setZipcode);
          await localStorage.setItem(
            CUST_SET_KITCHENS,
            `${custdata?.data?.kitchens_ForSetDeliveryAddress.kitchens[custdata?.data?.setZipcode]}`
          );

          // Filtering address then setting it to localstorage
          const address = custdata?.data?.delivery_address;
          const defaultAddresses =
            Array.isArray(address) && address.length > 0
              ? address.filter((item) => item.isDefault_address === true)
              : [];

          if (defaultAddresses.length > 0) {
            await localStorage.setItem(
              ZIPCODE_GEO_COORDINATES,
              defaultAddresses[0]?.Geolocation?.coordinates // we are taking coordinates from customer address
            );
          }

          const setLocalStorage = true;
          kitchenByZipcodeResponse = await onGetKitchenByZipcodeHandler(
            custdata?.data?.setZipcode,
            setLocalStorage
          );

          // const makeApiCall = true;
          // await onGetKitchenByZipcode(custdata?.data?.setZipcode, setLocalStorage, makeApiCall)
        }
        return { custData: custdata, zipCodeData: kitchenByZipcodeResponse };
      } else {
        await setCustomerInfoData({
          loading: false,
          data: null,
          success: custdata.data?.success,
          errorMessage: custdata.data?.CustomMessage,
        });
      }
      return;
    } catch (error) {
      console.log('-----Catch block onCustomerInformation', error);
      setCustomerInfoData({ data: null, isLoading: false, errorMessage: error, success: false });
    }
  };

  const onLogout = async () => {
    try {
      const gettingToken = () => localStorage.getItem(TOKEN);
      if (gettingToken()) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken()}`;
      }

      const logoutResop = await logoutAPI();
      if (logoutResop) {
        localStorage.clear();
        // localStorage.removeItem(REFRESH_TOKEN);
        // localStorage.removeItem(TOKEN);
        // localStorage.removeItem(ZIP_CODE);
        // localStorage.removeItem(KITCHEN_NAMES);
        // localStorage.removeItem(CUST_SET_ZIPCODE);
        // localStorage.removeItem(CUST_SET_KITCHENS);
        // localStorage.removeItem(CUSTINFO_API_FETCHED_TIME);
        // localStorage.removeItem(KITCHEN_API_FETCHED_TIME);
        // localStorage.removeItem(ZIPCODE_GEO_COORDINATES);
        await setIsDeliverable(false);
        await setIsLoggedIn(false);

        return;
      }
    } catch (error) {
      console.log('---Catch block onLogout', error);
    }
  };

  const onForgotPassword = async (payload) => {
    await setForgotPasswordData({
      loading: true,
      errors: null,
      data: null,
      errorMessage: '',
    });

    const data = await forgotPasswordAPI(payload);
    if (data.hasError) {
      await setForgotPasswordData({
        loading: false,
        data: null,
        errors: data.hasError,
        errorMessage: data.message,
      });
      return;
    }

    if (data.data.success) {
      await setForgotPasswordData({
        loading: false,
        data: data,
        errors: false,
        errorMessage: '',
      });
    } else {
      await setForgotPasswordData({
        loading: false,
        data: data,
        errors: !data.data.success,
        errorMessage: data.data.CustomMessage,
      });
    }
  };

  const onResetPassword = async (token, payload) => {
    try {
      await setResetPasswordData({
        loading: true,
        success: null,
        data: null,
        errorMessage: '',
      });

      const data = await resetPasswordAPI(token, payload);

      if (data.hasError) {
        await setResetPasswordData({
          loading: false,
          data: null,
          success: !data.hasError,
          errorMessage: data.message,
        });
        return;
      }

      if (data.data.success) {
        await setResetPasswordData({
          loading: false,
          data: data,
          success: true,
          errorMessage: '',
        });
      } else {
        await setResetPasswordData({
          loading: false,
          data: data,
          success: data?.data?.success,
          errorMessage: data?.data?.CustomMessage,
        });
      }
    } catch (error) {
      console.log('---Catch black onResetPassword', error);
      setResetPasswordData({ loading: false, data: null, success: false, errorMessage: error });
    }
  };

  const onUpdateCreditCard = async (payload) => {
    try {
      const gettingToken = localStorage.getItem(TOKEN);
      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setCustomerInfoData({
          loading: false,
          data: null,
          success: false,
          errorMessage: 'Token & Refresh Token missing',
          noKitchensFound: null,
        });
        return;
      }

      await setUpdateCreditCardData({
        loading: true,
        data: null,
        success: null,
        errorMessage: '',
      });

      const data = await updateCreditCardAPI(payload);

      if (data?.hasError) {
        await setUpdateCreditCardData({
          loading: false,
          data: null,
          success: !data.hasError,
          errorMessage: data?.message,
        });

        return data;
      }

      if (data?.data?.success) {
        await setUpdateCreditCardData({
          loading: false,
          data: data?.data,
          success: data.data?.success,
          errorMessage: null,
        });
      } else {
        await setUpdateCreditCardData({
          loading: false,
          data: data?.data,
          success: data.data?.success,
          errorMessage: data.data?.errors?.[0]?.ErrorMessage,
        });
      }

      return data;
    } catch (error) {
      console.log('-----Catch block onUpdateCreditCard', error);
      setUpdateCreditCardData({
        data: null,
        isLoading: false,
        errorMessage: error,
        success: false,
      });
    }
  };

  const ButtonSwitchSubscription = () => {
    // Customer is NOT loggedin
    if (!isLoggedIn && !custActType) {
      return {
        verbiage: 'Please login to add meal item',
        handleMethod: RedirectToLogin,
        buttonLabel: 'Login',
        promoCode: null,
      };
    }

    // Customer is logged in but account type is not subscription
    if (isLoggedIn && !custActType) {
      return {
        verbiage: 'Upgrade to subscription and get 2 free meals',
        handleMethod: RedirectToUpgradeSubscription,
        buttonLabel: 'Accept 2 Free Meals',
        promoCode: 'su123',
      };
    }

    // When Customer is logged in  and account type is subscription and dont have enough plates and reason status is Customer
    // unsubscribed redirecting to customer account subscription
    if (isLoggedIn && custActType && zeroPlatesAvailable && custAccountUnsubscribed) {
      return {
        verbiage: 'Reactivate meal subscription',
        handleMethod: RedirectToCustAcctSubscription,
        buttonLabel: 'Reactivate',
        promoCode: null,
      };
    }

    // Customer is subscription & loggedin & has zero plates available
    if (isLoggedIn && custActType && zeroPlatesAvailable) {
      return {
        verbiage: 'Not enough subscription meal plates',
        handleMethod: RedirectToUpgradeSubscription,
        buttonLabel: 'Add Meal Plate',
        promoCode: null,
      };
    }

    if (isLoggedIn && custAccountInactive) {
      triggerLogout();
      setLocalStorageDebug(DEBUG_LOGOUT_POINT, 'RestaurantMenuDesktop() NO9909');
      RedirectToLogin();
    }
  };

  return (
    <LoginDataContext.Provider
      value={{
        loginData,
        onLogin,
        forgotPasswordData,
        onForgotPassword,
        resetPasswordData,
        onResetPassword,
        isLoggedIn,
        setIsLoggedIn,
        onLogout,
        onCustomerInformationApiHandler,
        customerInfoData,
        setCustomerInfoData,
        setLoginData,
        onUpdateCreditCard,
        updateCreditCardData,
        setUpdateCreditCardData,
        ButtonSwitchSubscription,
        fingerPrint,
        setFingerPrint,
      }}
    >
      {children}
    </LoginDataContext.Provider>
  );
};

export default LoginDataProvider;
